import actions from '../../actions';
import timingClockReducer from './timingClock';
import refereeLightsReducer from './refereeLights';

import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

const currentInitialState = {
  protocol: null,
  lift: null,
};

const currentReducer = handleActions(
  {
    [actions.competition.begin]: (state, { payload: { protocol, lift } }) => ({
      protocol,
      lift,
    }),
    [actions.competition.end]: () => ({
      ...currentInitialState,
    }),
  },
  currentInitialState,
);

const stopReducer = handleActions(
  {
    [actions.competition.stop]: (state, { payload: { reason } }) => ({
      reason,
    }),
    [actions.competition.resume]: (state, action) => null,
  },
  null,
);

const reducer = combineReducers({
  current: currentReducer,
  timingClock: timingClockReducer,
  refereeLights: refereeLightsReducer,
  stop: stopReducer,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/venue/reducers/competition/index.js